import React from "react";
import NavPatient from "../../patients/navPatien/NavPatient";
import UpdateInfo from "../../patients/updateInfo/UpdateInfo";
import ChangePass from "../../patients/changePass/ChangePass";
import { useNavigate } from "react-router-dom";
import HeadBar from "../../public/headBar/HeadBar";
import Footer from "../../footer/Footer";
import Breadcrumb from "../breacrumb/breadcrumb"

function ManageInfo() {
  const navigate = useNavigate();
  const pathItems = [
    { name: "หน้าหลัก", url: `/` },
    { name: "จัดการข้อมูลส่วนตัว", url: `` },
  ];
  return (
    <>
      <div className="global-page">

        <Breadcrumb pathItems={pathItems} />
        <UpdateInfo />
    
      </div>
    </>
  );
}

export default ManageInfo;
